import { create } from "zustand";
import { PGNameEnum, PaymentElementEnum } from "@clubpay/customer-common-module/src/repository/common/payment/type";

type ForexRetry = {
  open: boolean;
  ui: "v1" | "v2";
  totalInForexCurrency?: number;
  totalInVendorCurrency?: number;
};

export type ExchangeRate = {
  currencyCode: string;
  value: number;
};
export interface ForexState {
  exchangeRate: number;
  currencyCode: string | null;
  currencyPrecision: number;
  vendorCurrencyCode: string | null;
  pgName: PGNameEnum | null;
  paymentMethod: PaymentElementEnum | null;
  paymentMethodOrder?: number | null;
  isApplied: boolean;
  isInterrupted: boolean;
  isAvailable: boolean;
  isRoutingApplied?: boolean;
  isReallocationEnabled: boolean;
  isForexAvailableAtBeginning: boolean;
  isDisabled: boolean;
  tip: number;
  total: number;
  forexRetry: ForexRetry;
  exchangeRates: ExchangeRate[];
  normalize3To2: boolean;
}

const initialState: ForexState = {
  exchangeRate: 0,
  currencyCode: null,
  currencyPrecision: 2,
  vendorCurrencyCode: null,
  pgName: null,
  paymentMethod: null,
  paymentMethodOrder: null,
  isApplied: false,
  isInterrupted: false,
  isAvailable: false,
  isRoutingApplied: false,
  isReallocationEnabled: false,
  isForexAvailableAtBeginning: false,
  isDisabled: false,
  tip: 0,
  total: 0,
  forexRetry: {
    open: false,
    ui: "v1",
    totalInForexCurrency: 0,
    totalInVendorCurrency: 0
  },
  exchangeRates: [],
  normalize3To2: false
};

export const useForexStore = create<ForexState>()(() => ({
  ...initialState
}));

export const setForex = (args: Partial<ForexState>) =>
  useForexStore.setState((state: ForexState) => ({ ...state, ...args }));

export const setExchangeRates = (exchangeRates: ExchangeRate[]) => useForexStore.setState(() => ({ exchangeRates }));

export const resetForex = () => useForexStore.setState(() => ({ ...initialState }));

export const setForexRetry = (args: Partial<ForexRetry>) => {
  useForexStore.setState((state: ForexState) => ({
    ...state,
    forexRetry: {
      ...state.forexRetry,
      ...args
    }
  }));
};
